import { combineReducers } from 'redux'

import * as constants from './constants'
import { SEARCH_MODE_HOURLY, SEARCH_MODE_EVENTS, SEARCH_MODE_PREPAID } from 'search/constants'
import { getInitSearchMode } from './helpers'
import { getDefaultCoordinates } from 'shared/country'
import * as bookingConstants from 'booking/constants'

function apiReady(state = false, action) {
    if (action.type === constants.MAP_GOOGLE_API_LOADED) return true
    return state
}

function rates(state = [], action) {
    if (action.type === constants.SET_RATES) return action.rates
    return state
}

const resultsDefaultState = {
    results: [],
    poi: [],
    resultsCount: 0,
    resultsMode: constants.SHOW_MAP_SEARCH_RESULTS,
}

function results(state = resultsDefaultState, action) {
    if (action.type === constants.RECEIVED_MAP_RESULTS)
        return {
            results: action.results,
            resultsCount: action.resultsCount,
            poi: action.placesOfInterest,
        }
    return state
}

function searchLocation(state = getDefaultCoordinates(), action) {
    switch (action.type) {
        case constants.SET_MAP_LOCATION:
        case constants.SET_MAP_BOUNDS:
            return action.searchLocation

        default:
            return state
    }
}

function zoom(state = 13, action) {
    switch (action.type) {
        case constants.SET_MAP_ZOOM:
        case constants.SET_MAP_BOUNDS:
        case constants.GET_USER_LOCATION:
            return action.zoom

        default:
            return state
    }
}

function center(state = getDefaultCoordinates(), action) {
    switch (action.type) {
        case constants.GET_USER_LOCATION:
            return action.userLocation
        case constants.SET_MAP_LOCATION:
        case constants.SET_MAP_BOUNDS:
            return action.searchLocation
        case constants.SET_MAP_ACTIVE_SEARCH_LOCATION:
            return action.activeSearchLocation
        case constants.SET_MAP_ACTIVE_LOCATION:
            return action.location ? action.location : state
        default:
            return state
    }
}

function maxBounds(state = null, action) {
    if (action.type === constants.SET_MAXIMUM_MAP_BOUNDS) return action.maxBounds || state
    return state
}

function bounds(state = null, action) {
    if (action.type === constants.SET_MAP_BOUNDS) return action.bounds || state
    return state
}

function filters(state = {}, action) {
    if (action.type === constants.SET_MAP_FILTERS) return action.filters
    return state
}

function resultsMode(state = null, action) {
    if (action.type === constants.SET_MAP_SEARCH_RESULTS_VIEW) return action.mode
    return state
}

function searchMode(state = getInitSearchMode(window.COUNTRY), action) {
    switch (action.type) {
        case constants.SET_MAP_SEARCH_MODE:
        case bookingConstants.SET_PARKING_MODE:
            return action.searchMode
        case bookingConstants.EXIT_BOOKING_FLOW:
            return [SEARCH_MODE_EVENTS, SEARCH_MODE_PREPAID].includes(state) ? SEARCH_MODE_HOURLY : state
        default:
            return state
    }
}

function activeLocation(state = null, action) {
    const { type, activeLocation } = action

    if (type === constants.SET_MAP_ACTIVE_LOCATION) return activeLocation

    return state
}

function hoveredLocation(state = null, action) {
    const { type, hoveredLocation } = action

    if (type === constants.SET_MAP_HOVERED_LOCATION) return hoveredLocation

    return state
}

function activeSearchLocation(state = null, action) {
    const { type, activeSearchLocation } = action

    if (type === constants.SET_MAP_ACTIVE_SEARCH_LOCATION) return activeSearchLocation

    return state
}

function scrollIntoView(state = false, action) {
    const { type, scrollToActiveLocation } = action

    if (type === constants.SET_MAP_ACTIVE_LOCATION) return scrollToActiveLocation

    return state
}

export const map = combineReducers({
    apiReady,
    rates,
    results,
    maxBounds,
    bounds,
    filters,
    resultsMode,
    searchMode,
    activeLocation,
    hoveredLocation,
    activeSearchLocation,
    scrollIntoView,
    searchLocation,
    zoom,
    center,
})
